/**
 * Google Calendar API module
 */
import { API_URL } from '../config';
import { getAuthHeaders } from '../utils/fetchWrapper';

/**
 * Get Google OAuth2 authorization URL
 */
export const getCalendarAuthUrl = async () => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetch(`${API_URL}/api/calendar/auth-url`, { headers });
    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      return { error: err.error || 'Error al obtener URL de autorización' };
    }
    return await resp.json();
  } catch (error) {
    console.error('Error getCalendarAuthUrl:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * Send the OAuth callback code to the backend
 */
export const sendCalendarCallback = async (code) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetch(`${API_URL}/api/calendar/callback`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ code }),
    });
    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      return { error: err.error || 'Error al conectar Google Calendar' };
    }
    return await resp.json();
  } catch (error) {
    console.error('Error sendCalendarCallback:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * Disconnect Google Calendar
 */
export const disconnectCalendar = async () => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetch(`${API_URL}/api/calendar/disconnect`, {
      method: 'POST',
      headers,
    });
    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      return { error: err.error || 'Error al desconectar' };
    }
    return await resp.json();
  } catch (error) {
    console.error('Error disconnectCalendar:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * Get Google Calendar events for a date range
 * @param {string} from - Start date YYYY-MM-DD
 * @param {string} to - End date YYYY-MM-DD
 */
export const getCalendarEvents = async (from, to) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetch(`${API_URL}/api/calendar/events?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`, { headers });
    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      return { error: err.error || 'Error al obtener eventos' };
    }
    return await resp.json();
  } catch (error) {
    console.error('Error getCalendarEvents:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * Get Google Calendar connection status
 */
export const getCalendarStatus = async () => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetch(`${API_URL}/api/calendar/status`, { headers });
    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      return { error: err.error || 'Error al obtener estado' };
    }
    return await resp.json();
  } catch (error) {
    console.error('Error getCalendarStatus:', error);
    return { error: 'Error de conexión' };
  }
};
